import React from 'react'

function Header() {
  return (
    <div className="app__header">
      <h1 className="app__title">snippet generator</h1>
    </div>
  )
}

export default Header
